var map = {
	"./Base/serverStyle": 123,
	"./Clutch/serverStyle": 1843,
	"./NewUi/serverStyle": 1844,
	"./OldUi/serverStyle": 1845,
	"./SpireonNew/serverStyle": 1846,
	"./SpireonOld/serverStyle": 1847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;